import React, { useState } from 'react'
import { Boton } from './style.css'

const Alternativa = ({ data, onSelect, bgcolor }) => {
  const { alternativa, respuestaCorrecta } = data

  const handleSelect = () => {
    onSelect({
      alternativa,
      respuestaCorrecta,
    })
  }
  const [hovered, setHovered] = useState(false)

  return (
    <Boton
      className={`block w-full text-xl ${hovered ? 'isHovered' : ''}`}
      style={{ transition: 'all 0.3s', backgroundColor: bgcolor }}
      value={alternativa}
      onClick={() => handleSelect()}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      <span>{alternativa}</span>
    </Boton>
  )
}

export default Alternativa
